var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 16.4344V7.56562C20.6243 7.4321 20.5884 7.30112 20.5209 7.18591C20.4534 7.07069 20.3567 6.97531 20.2406 6.90937L12.3656 2.45625C12.2545 2.39206 12.1284 2.35828 12 2.35828C11.8716 2.35828 11.7455 2.39206 11.6344 2.45625L3.75937 6.90937C3.64327 6.97531 3.5466 7.07069 3.47911 7.18591C3.41163 7.30112 3.37572 7.4321 3.375 7.56562V16.4344C3.37572 16.5679 3.41163 16.6989 3.47911 16.8141C3.5466 16.9293 3.64327 17.0247 3.75937 17.0906L11.6344 21.5437C11.7455 21.6079 11.8716 21.6417 12 21.6417C12.1284 21.6417 12.2545 21.6079 12.3656 21.5437L20.2406 17.0906C20.3567 17.0247 20.4534 16.9293 20.5209 16.8141C20.5884 16.6989 20.6243 16.5679 20.625 16.4344V16.4344Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.375C13.864 15.375 15.375 13.864 15.375 12C15.375 10.136 13.864 8.625 12 8.625C10.136 8.625 8.625 10.136 8.625 12C8.625 13.864 10.136 15.375 12 15.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.0277e8ee455721cb6ed25856949c6961.svg";
export { ForwardRef as ReactComponent };